module.exports = __webpack_public_path__ + "static/media/real5.97264d26.jpg";